export const JOY_HELP_URL = 'https://help.withjoy.com/';
export const JOY_ABOUT_URL = 'https://withjoy.com/about/';
export const DEFAULT_HOTEL_IMAGE = 'https://withjoy.com/assets/public/hotelselection/empty-hotel-item-v2.png';
export const DEFAULT_HOTEL_IMAGE_WIDE = 'https://withjoy.com/assets/public/hotelselection/empty-hotel-item-v2-wide.png';
